module.exports = __webpack_public_path__ + "static/img/project-hooq.42bc91c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/project-hooq.png
// module id = ZrvR
// module chunks = 1